import { getSafeColor } from "services/utils";

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// Styles for SidenavCollapse (collapseItem function)
const collapseItem = (theme, { active }) => {
  const { palette, functions } = theme;
  const { sideNav } = palette;
  const { rgba, pxToRem } = functions;

  return {
    // Active background is a subtle tint of the text color
    borderRadius: "6px",
    margin: `1px ${pxToRem(8)}`,
    padding: `${pxToRem(9)} ${pxToRem(12)}`,
    display: "flex",
    alignItems: "center",
    width: "calc(100% - 16px)",
    cursor: "pointer",
    position: "relative",
    backgroundColor: active ? rgba(getSafeColor(sideNav.contrastText), 0.12) : "transparent",
    transition: "background-color 160ms ease, color 160ms ease",

    // 💡 The Glowing Active Pill
    "&:after": {
      content: active ? '""' : "none",
      position: "absolute",
      insetInlineStart: 0,
      width: "3px",
      height: "22px",
      backgroundColor: getSafeColor(sideNav.contrastText),
      borderRadius: "0 3px 3px 0",
    },

    "&:hover": {
      backgroundColor: rgba(getSafeColor(sideNav.contrastText), active ? 0.14 : 0.07),
    },
  };
};
function collapseIconBox(theme) {
  const { palette, transitions, borders, functions } = theme;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    minWidth: pxToRem(26),
    minHeight: pxToRem(26),
    color: palette.sideNav.contrastText,
    borderRadius: borderRadius.sm,
    display: "grid",
    placeItems: "center",
    transition: transitions.create("color", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g": {
      fontSize: pxToRem(16),
      color: "inherit",
    },
  };
}

const collapseIcon = (theme) => ({
  color: theme.palette.sideNav.contrastText,
  fontSize: "1rem",
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions, palette } = theme;
  const { miniSidenav, active } = ownerState;

  const { fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(8),
    color: palette.sideNav.contrastText,

    [breakpoints.up("xl")]: {
      opacity: miniSidenav ? 0 : 1,
      maxWidth: miniSidenav ? 0 : "100%",
      marginLeft: miniSidenav ? 0 : pxToRem(8),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: pxToRem(13),
      lineHeight: 1.3,
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
